import { render, staticRenderFns } from "./FormTextInput.vue?vue&type=template&id=bfb0ef52&scoped=true"
import script from "./FormTextInput.vue?vue&type=script&lang=js"
export * from "./FormTextInput.vue?vue&type=script&lang=js"
import style0 from "./FormTextInput.vue?vue&type=style&index=0&id=bfb0ef52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb0ef52",
  null
  
)

export default component.exports